// extracted by mini-css-extract-plugin
export default {"root":"jDEaK0","icon":"OBCYHa","ltr":"hqlzgp","withCount":"W5kM9K","badge":"CKaa7w","rtl":"J4dmwY"};